import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-9da2e740"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "pagination-pager"
};
var _hoisted_2 = {
  key: 0,
  class: "total"
};
export default /*#__PURE__*/_defineComponent({
  props: {
    options: Object,
    params: Object // 必传参数

  },
  emits: ['onChange'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;

    // methods
    var handleCurrentChange = function handleCurrentChange(val) {
      emit('onChange', {
        pageNo: val
      });
    };

    var handleSizeChange = function handleSizeChange(val) {
      emit('onChange', {
        pageSize: val,
        pageNo: 1
      });
    };

    return function (_ctx, _cache) {
      var _component_el_pagination = _resolveComponent("el-pagination");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.options.total > __props.params.pageSize ? (_openBlock(), _createElementBlock("span", _hoisted_2, "共" + _toDisplayString(__props.options.total) + "项数据", 1)) : _createCommentVNode("", true), _createVNode(_component_el_pagination, {
        "hide-on-single-page": true,
        background: "",
        "current-page": __props.params.pageNo,
        "page-size": __props.params.pageSize,
        total: __props.options.total,
        "page-sizes": [10, 20, 50, 100, 500],
        layout: "prev, pager, next, sizes, jumper",
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "total"])]);
    };
  }
});